import { css } from 'styled-components'

const extendStylesDropdownOffice = css`
    width: 230px;
`

export { extendStylesDropdownOffice }
